import type { ServerError } from '../models/serverError'

export type AgentHttpConfig = {
  getToken: () => string | null
  onServerError: (error: ServerError) => void
}

/**
 * Defaults until `configureAgentHttp` runs from `store.ts` (reads jwt from localStorage).
 * After bootstrap, `getToken` should come from `commonStore` so interceptors match MobX auth state.
 */
let config: AgentHttpConfig = {
  getToken: () => window.localStorage.getItem('jwt'),
  onServerError: () => {}
}

export function configureAgentHttp (partial: Partial<AgentHttpConfig>): void {
  config = { ...config, ...partial }
}

export function getAgentAuthToken (): string | null {
  return config.getToken()
}

export function reportAgentServerError (error: ServerError): void {
  config.onServerError(error)
}
